import get from 'lodash/get';

const giaSerializer = (response) => {
  const giaItems = get(response, 'data.gia.items', []);

  return giaItems.map(item => ({
    ...item,
    registration_code: item.registration_code.replace(/[^0-9]+/gi, ''),
    document_number: item.document_number.replace(/[^0-9]+/gi, ''),
  }));
};

export default giaSerializer;
